exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table td[data-v-576e503c], .table th[data-v-576e503c] {\n  padding: 0.1rem;\n  vertical-align: top;\n  border-top: .0625rem solid #e7eaf3;\n}\n\n", ""]);

// exports
